import React, { useEffect, useRef } from 'react';

import CommonCarousel from '../../../../../../components/common-carousel/CommonCarousel';
import { clampMediaIndex } from '../../../../../utils/mediaIndex';
import { getStoryMediaId } from '../../../../media/storyMediaItem';
import SelectedMediaHeroSlide from './SelectedMediaHeroSlide';

import scss from './SelectedMediaHero.module.scss';

function SelectedMediaHero({ items, activeIndex, onActiveIndexChange, onPreview, onRemoveSingle }) {
  const carouselRef = useRef(null);
  const hasMultiple = items.length > 1;
  const safeIndex = clampMediaIndex(activeIndex, items.length);
  const showSingleRemove = items.length === 1 && onRemoveSingle;

  useEffect(() => {
    if (!hasMultiple) {
      return;
    }

    carouselRef.current?.goToSlide(safeIndex);
  }, [hasMultiple, safeIndex]);

  const slideProps = {
    onPreview,
    onRemove: showSingleRemove ? onRemoveSingle : undefined,
  };

  if (!hasMultiple) {
    return (
      <div className={scss.wrapper}>
        <SelectedMediaHeroSlide media={items[0]} {...slideProps} />
      </div>
    );
  }

  return (
    <div className={scss.wrapper}>
      <CommonCarousel
        ref={carouselRef}
        onBeforeChange={(_, next) => onActiveIndexChange(next)}
        initialSlide={safeIndex}
        contrastedArrows>
        {items.map((media) => (
          <SelectedMediaHeroSlide key={getStoryMediaId(media)} media={media} onPreview={onPreview} />
        ))}
      </CommonCarousel>
    </div>
  );
}

export default SelectedMediaHero;
